import axios from 'axios';
import Jsona from 'jsona';
import config from '../../config';
import http from '../api/http';

/** Fetch service requirements independently of the default Documents upload listing. */
export const requestServiceDocumentTypes = (businessCode, countryCode) => {
  const source = axios.CancelToken.source();
  const promise = http.get(config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_ID_TYPES_LISTINGS_URI, {
    params: { businessCode, countryCode },
    cancelToken: source.token,
  }).then(({ data }) => {
    const result = new Jsona().deserialize(data);
    if (!Array.isArray(result) || !result.length) {
      throw new Error('Invalid document requirements response');
    }
    return result;
  });
  return { promise, abort: () => source.cancel('Document selection changed') };
};
